const Consultant = () => {

	Array.from(document.querySelectorAll('.consultant .arrow-back')).forEach(item => {
		if (!document.referrer || document.referrer.indexOf(document.location.host) < 0) {
			return false;
		}

		item.addEventListener('click', event => {
			event.preventDefault();
			window.history.go(-1);
			return false;
		});
	});

	Array.from(document.querySelectorAll('.side-navigation--consultant .nav-link')).forEach(item => {
		if (!document.referrer || document.referrer.indexOf(document.location.host) < 0) {
			return false;
		}

		item.addEventListener('click', event => {
			event.preventDefault();
			window.history.go(-1);
			return false;
		});
	});

};

export default Consultant;
